import { Debug } from '~';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { STATUSES, STEP_STATUS } from '@/util/constants';
import WorkflowProgress from '@/components/rabbit/workflow-progress/WorkflowProgress.vue';

const debug = Debug('campaign-workflow'); // eslint-disable-line

const stepDisplayStatus = step => {
  if (step.code === STATUSES.FIN || step.code === STATUSES.ONL) {
    if (step.currentStatus === STEP_STATUS.in_progress) {
      return STEP_STATUS.completed;
    }
  }

  return step.currentStatus;
};

export default {
  components: {
    'workflow-progress': WorkflowProgress,
  },
  data() {
    return {
      stepStatus: STEP_STATUS,
    };
  },
  methods: {
    getFinishedAt(step) {
      let nextSteps = _.get(this.campaign, 'steps.steps', []);
      nextSteps = nextSteps
        .slice(nextSteps.indexOf(step) + 1)
        .filter(s => s.startedAt);
      return nextSteps.length ? nextSteps[0].startedAt : null;
    },
  },
  computed: {
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    steps() {
      return _.get(this.campaign, 'steps.steps', [])
      .filter(s => s.code !== STATUSES.CAN && s.code !== STATUSES.INI)
      .map(s => {
        const newStep = {
          status: stepDisplayStatus(s),
          name: this.$t(`terms.statuses.${s.code}`),
          code: s.code,
          startedAt: s.startedAt,
          finishedAt: this.getFinishedAt(s),
        };

        return newStep;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/campaign-workflow/CampaignWorkflow.js